<script lang="ts">
  import Icon from '$lib/components/Icon.svelte';
  import type { Snippet } from 'svelte';
  import { twMerge } from 'tailwind-merge';

  interface Props {
    title?: string | null;
    size?: string;
    collapsable?: boolean;
    collapsed?: boolean;
    variant?: 'primary' | 'secondary' | 'warning';
    class?: string;
    children?: Snippet;
  }

  let {
    title = null,
    size = 'md',
    collapsable = false,
    collapsed = $bindable(true),
    variant = 'primary',
    class: className = '',
    children,
  }: Props = $props();

  const sizes = $derived(
    {
      xs: 'p-1 text-xs',
      md: 'p-3 text-md',
      lg: 'p-4 text-lg',
      xl: 'p-8 text-xl',
    }[size],
  );

  const variants = $derived(
    {
      primary: 'bg-white dark:bg-gray-9',
      secondary: 'dark:bg-white',
      warning:
        'border-[1px] border-opacity-50 border-[#f59e0b] text-[#f59e0b] rounded-md dark:bg-gray-9',
    }[variant],
  );

  let cardClasses = $derived(
    twMerge('relative w-full rounded-sm', variants, sizes, className),
  );
</script>

<div class={cardClasses}>
  {#if collapsable}
    <button
      onclick={() => (collapsed = !collapsed)}
      class="group mb-0 flex w-full items-center justify-between"
    >
      {#if title}
        <h3 class="font-mono dark:text-white ${sizes}">{title}</h3>
      {/if}
      <div
        class={twMerge(
          'flex items-center justify-center text-gray-3 transition group-hover:text-white',
          !collapsed && 'rotate-180',
        )}
      >
        <Icon icon="chevronDown" />
      </div>
    </button>
  {/if}
  {#if !collapsable && title}
    <h3 class="font-mono dark:text-white ${sizes}">{title}</h3>
  {/if}
  <div>
    {#if collapsable}
      {#if !collapsed}
        <div class={title && 'pt-4'}>
          {@render children?.()}
        </div>
      {/if}
    {:else}
      {@render children?.()}
    {/if}
  </div>
</div>
